module.exports = __webpack_public_path__ + "img/violet_092.04c393c9.png";